import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Roboto', sans-serif;
  position: relative;
  padding: 48px 40px 40px;
  background-color: ${(props) => props.theme.$white};

  .close-button {
    position: absolute;
    top: 16px;
    right: 20px;
    background: transparent;
    border: none;
    color: ${(props) => props.theme.$dark};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    z-index: 2;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }

    .material-icons {
      font-size: 20px;
    }
  }

  .promo-video {
    width: 100%;
    aspect-ratio: 16 / 9;
    min-height: 320px;
    border: 0;
    background-color: ${(props) => props.theme.$black};
    margin-bottom: 24px;
  }

  .promo-title {
    font-size: 20px;
    font-weight: 700;
    color: ${(props) => props.theme.$dark};
    margin-bottom: 16px;
  }

  .promo-subtitle {
    font-size: 15px;
    font-weight: 500;
    color: ${(props) => props.theme.$dark};
    margin-bottom: 32px;
  }

  .promo-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
`;
